<template>
  <el-dialog
    :visible.sync="visible"
    class="download-result-dialog"
    :before-close="handleClose"
  >
    <slot name="title"></slot>
    <el-row>
      <el-col class="mb-12">商品总数：{{total}}款，成功{{success}}款，失败{{failure}}款</el-col>
      <el-col v-if="!isShowBtn && message">失败数据：{{message}}</el-col>
      <el-col class="join-distributor-log-result" v-if="joinDistributorLogResult && joinDistributorLogResult.totalNum">
        <el-col>
          加入分销商小店：成功 {{joinDistributorLogResult.successNum || 0}}款，失败{{joinDistributorLogResult.failureNum || 0}}款
        </el-col>
        <el-col v-if="joinDistributorLogResult.errorMsg">
          失败原因：{{joinDistributorLogResult.errorMsg}}
        </el-col>
      </el-col>
    </el-row> 
    <span slot="footer" class="dialog-footer" v-if="isShowBtn">
      <el-button @click="handleJump">查看日志</el-button>
      <template v-if="['platformDownload', 'erpImport'].includes(type)">
        <template v-if="(total === 1) && (success === 1)">
          <el-button type="primary" @click="handleEditProd">编辑商品</el-button>
        </template>
        <template v-else-if="success >= 1">
          <el-button type="primary" @click="handleJumpProdCenter">查看商品</el-button>
        </template>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'DownloadResult',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    resultData: {
      type: Object,
      default: () => {
        return {
          successNum: 0,
          totalNum: 0,
          message: ''
        }
      }
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
    }
  },
  data(){
    return{
      self_result: '',
      joinDistributorLogResult: ''
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    total() {
      return this.self_result.totalNum || this.self_result.total || 0
    },
    success() {
      return this.self_result.successNum || this.self_result.success || 0
    },
    successList() {
      return this.self_result.successList || []
    },
    failure() {
      return this.total - this.success || 0
    },
    message() {
      return this.self_result.message || ''
    },
  },
  watch: {
    resultData: {
      handler(val) {
        this.self_result = {...val};
        this.joinDistributorLogResult = {...val.joinDistributorLogResult || ''};
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['setActiveName']),
    handleClose() {
      this.$emit('update:visible', false)
      if(!this.isShowBtn) {
        this.$emit('search')
      }
      if(this.isEdit) {
         this.$emit('search',true)
      } else {
        this.$emit('search',false)
      }
    },
    // 跳到商品日志中商品新增tab页
    handleJump() {
      this.setActiveName('newProductLog');
      this.$emit('update:visible', false);
      this.$emit('onJump')
      this.$router.push({name: `${this.routerPrefix}prod_log`});
    },
    handleJumpProdCenter() {
      this.$emit('update:visible', false);
      this.$emit('onJump')
      // this.$router.push({
      //   name: `${this.routerPrefix}prod_center`
      // });
    },
    handleEditProd() {
      this.$emit('update:visible', false);
      const { baseItemId } = this.successList[0];
      this.$emit('edit', baseItemId);
    },
  }
}
</script>

<style lang="scss" scoped>
.download-result-dialog {
  ::v-deep .el-dialog__body {
    padding: 30px;
  }
  i.el-icon-circle-check {
    color: #67c23a;
    font-size: 22px;
    margin-right: 10px;
    margin-top: -5px;
  }
  .title {
    color: #292020;
    font-size: 16px;
    font-weight: 600; 
  }
  p {
    padding-left: 60px
  }
  .failed-box {
    margin-top: 20px;
  }
  .mb-12{
    margin-bottom: 12px;
  }
  .join-distributor-log-result{
    background-color:#FAFAFA;
    padding: 10px;
  }
}
</style>